import { render, staticRenderFns } from "./CaseCardForHome.vue?vue&type=template&id=4f13e6fa&"
import script from "./CaseCardForHome.vue?vue&type=script&lang=js&"
export * from "./CaseCardForHome.vue?vue&type=script&lang=js&"
import style0 from "./CaseCardForHome.vue?vue&type=style&index=0&id=4f13e6fa&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports